export const GetCprStatusName = (input) => {
    if(!input) return ""
    let data = require('../../assets/CprStatus.json')
    let status = data.find(el => el.Datafordelertekst === input)
    return status ? status.Kode + " (" + status.Ledetekst + ")" : input;
}

export const GetCprStatusKode = (input) => {
    if(!input) return "blank"
    let data = require('../../assets/CprStatus.json')
    let status = data.find(el => el.Datafordelertekst === input)
    return status ? status.Kode : input;
}

export const IsCprStatusValidForDriverCards = (input) => {
    if(!input) return false
    let data = require('../../assets/CprStatus.json')
    let status = data.find(el => el.Datafordelertekst === input)
    return status ? (status.Kode === "01" || status.Kode === "03" || status.Kode === "20") : input;
}
export const IsCprStatusValidForNonDriverCards = (input) => {
    if(!input) return false
    let data = require('../../assets/CprStatus.json')
    let status = data.find(el => el.Datafordelertekst === input)
    return status ? status.Kode === "01" : input;
}

export const IsCprStatusValidForDriverCardToEkspeditionssted = (input) => {
    if(!input) return false
    let data = require('../../assets/CprStatus.json')
    let status = data.find(el => el.Datafordelertekst === input)
    return status ? (status.Kode === "03" || status.Kode === "20" ) : input;
}

